import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Shared UI feedback for the self-service feature: snackbar notifications and
 * the transient error / success message strings.
 *
 * Extracted from SelfServiceVisualizationComponent because every stage
 * (data-builder, chart-builder, dashboard-builder) raises the same kind of
 * snack/message feedback. Having one service means the stage components don't
 * each re-implement showSnack, and the shell doesn't have to relay messages via
 * @Output plumbing.
 *
 * `viewMode` is intentionally NOT here — it controls which stage is shown and
 * belongs to the shell component.
 */
@Injectable({ providedIn: 'root' })
export class SelfServiceUiService {
  private readonly snackBar = inject(MatSnackBar);

  showSnack(message: string, type: 'success' | 'error', durationMs = 4000): void {
    this.snackBar.open(message, '✕', {
      duration: durationMs,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: type === 'success' ? ['ss-snack-success'] : ['ss-snack-error'],
    });
  }

  /** Convenience helpers mirroring the monolith's setter side-effects. */
  showError(message: string, durationMs?: number): void {
    if (message) {
      this.showSnack(message, 'error', durationMs);
    }
  }

  showSuccess(message: string, durationMs?: number): void {
    if (message) {
      this.showSnack(message, 'success', durationMs);
    }
  }
}
